import React from 'react';
function ConfigPage() {
  const [apiPath, setApiPath] = React.useState('');
  const [response, setResponse] = React.useState(null);
  const [error, setError] = React.useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(apiPath);
      const data = await res.json();
      setResponse(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      setResponse(null);
    }
  };

  return (
    <div className="container mx-auto p-8">
      <div className="bg-white rounded-lg mt-8 shadow-lg p-6">
        <h1 className="text-3xl font-bold mb-6">API Configuration</h1>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="apiPath" className="block text-sm font-medium text-gray-700">
              API Path
            </label>
            <input
              type="text"
              id="apiPath"
              value={apiPath}
              onChange={(e) => setApiPath(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              placeholder="Enter API path"
            />
          </div>
          
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Test API
          </button>
        </form>

        {error && (
          <div className="mt-4 p-4 bg-red-100 text-red-700 rounded">
            Error: {error}
          </div>
        )}

        {response && (
          <div className="mt-4">
            <h2 className="text-xl font-semibold mb-2">Response:</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-auto">
              {JSON.stringify(response, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}

export default ConfigPage; 